import React, { useEffect, useState } from "react"
import {
  Alert,
  CircularProgress,
  Typography,
} from "@mui/material"
import UsersTable from "./EnabledUsers/TableNavigable"
import { getAllTypesUser } from "../../../redux/actions/User"
import { useDispatch } from "react-redux"

export const AdminAccessOrganizationUsersTable = ({
  users,
  loading,
  applicationInstanceId,
  onConfigureUser,
}) => {
  const dispatch = useDispatch()

  const [typesUser, settypesUser] = useState([])
  const getAllTypes = async () => {
    try {
      const types = await dispatch(getAllTypesUser())
      settypesUser(types)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAllTypes()

  }, [])
  return (
    <div style={{ width: '100%' }}>
      <Typography variant="h6" sx={{ padding: 2 }}>
        Usuarios de la organización
      </Typography>

      {!applicationInstanceId ? (
        <Alert severity="info">
          Primero debe existir una instancia activa de la aplicación para la organización.
        </Alert>
      ) : null}

      {loading ? (
        <CircularProgress size={24} />
      ) : !users?.length ? (
        <Alert severity="warning">
          No hay usuarios para mostrar o todavía falta integrar el endpoint correspondiente.
        </Alert>
      ) : (
        <UsersTable
          rows={users}
          onConfigureUser={onConfigureUser}
          typesUser={typesUser}
        />
      )}
    </div>
  )
}

export default AdminAccessOrganizationUsersTable
